export const COMPONENT_NAME = "kyb-registration-information";
